import { render, staticRenderFns } from "./UploadContainerDocuments.vue?vue&type=template&id=3a895e94&scoped=true"
import script from "./UploadContainerDocuments.vue?vue&type=script&lang=js"
export * from "./UploadContainerDocuments.vue?vue&type=script&lang=js"
import style0 from "./UploadContainerDocuments.vue?vue&type=style&index=0&id=3a895e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a895e94",
  null
  
)

export default component.exports